import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError } from 'react-jsonschema-form'

const ls = LocalizationStore.getInstance()

export function loginFormSchema(): any {
    return {
        'title': ls.t!('Sign in to your pages account'),
        'type': 'object',
        'required': [
            'email',
            'password'
        ],
        'properties': {
            'email': {
                'title': ls.t('Enter login'),
                'type': 'string'
            },
            'password': {
                'title': ls.t('Password'),
                'type': 'string'
            }
        }
    }
}

export const UILoginFormSchema = {
    'email': {
        'ui:autofocus': true
    },
    'password': {
        'ui:widget': 'password'
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['property'] === '.email') {
            // TODO: just example
            // error['message'] = ls.t('Логин должен содержать не меньше 5 символов')
        }
        return error
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/LoginForm.tsx